import domReady from '@wordpress/dom-ready';

domReady(() => {
  const partnerList = document.querySelector('.partners__listing--public');

  if (partnerList) {
    putMemberInListing(determineMemberCount());
    const findstr = window.findstr || {};
    findstr.hooks.addAction(
      'afterSearchResults',
      'partnersListing',
      (results, group) => {
        if ('partners' !== group) {
          return;
        }
        if (results.totalHits > determineMemberCount()) {
          putMemberInListing(determineMemberCount());
        }
      }
    );
  }
});

function putMemberInListing(count) {
  const partnerItems = document.querySelectorAll('.post-item__partner');
  const memberItem = document.querySelector('.become-member__block-in-search');
  if (partnerItems.length > count && memberItem) {
    partnerItems[count - 1].after(memberItem);
  }
}

function determineMemberCount() {
  const windowWidth = window.innerWidth;
  let count = 8;

  if (windowWidth < 1201 && windowWidth > 991) {
    count = 9;
  } else if (windowWidth <= 991 && windowWidth > 767) {
    count = 10;
  }

  return count;
}

window.addEventListener('resize', () => {
  putMemberInListing(determineMemberCount());
});
